import type {FunctionComponent, Key, MouseEvent, ReactNode, SVGProps} from "react";
import styled from "styled-components";
import type {IDropdownOption, ISubOptionWrapper} from "../interaction/DropdownOptionsV5";
import {baseDistance, VerticalFlexStyle} from "../styles/styles";
import type {NavigationEnum} from "../../../Enums";
import {DropdownButtonStyled} from "../interaction/DropdownButtonV5";

export type TMenuV5 = {
	readonly label: string;
	readonly nav?: NavigationEnum;
	readonly icon: FunctionComponent<SVGProps<SVGSVGElement> & {title?: string}>;
	readonly onlyIcon?: boolean;
	readonly small?: boolean;
	readonly isActive?: boolean;
	readonly key?: Key;
	readonly onClick?: () => void;
	readonly onPlusClick?: (event: MouseEvent) => void;
	readonly dropdownOptions?: (IDropdownOption | ISubOptionWrapper)[];
	readonly floatingMenu?: ReactNode;
	readonly closeFloatingMenu?: () => void; // should be provided if floatingMenu is provided
};

export const NavMenuStyled = styled.div`
	${VerticalFlexStyle}
	${DropdownButtonStyled} {
		max-height: 24px;
		min-width: 24px;
	}

	.emptyViews {
		padding: ${baseDistance.sm} ${baseDistance.sm} ${baseDistance.md} ${baseDistance.sm};
	}
`;
